import { render } from "./contactMini.vue?vue&type=template&id=4868eba0&scoped=true"
import script from "./contactMini.vue?vue&type=script&lang=js"
export * from "./contactMini.vue?vue&type=script&lang=js"

import "./contactMini.vue?vue&type=style&index=0&id=4868eba0&lang=css"
import "./contactMini.vue?vue&type=style&index=1&id=4868eba0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4868eba0"]])

export default __exports__